export function initHomeHeroIndex() {
    const hero = document.querySelector('.home-hero');
    if (!hero) return;

    const panels = [...hero.children].filter(
        (el) => el.classList?.contains('hero-panel')
    );
    const dots = [...hero.querySelectorAll('.hero-index [data-index]')];
    const heroIndex = hero.querySelector('.hero-index');
    const lastPanel = panels[panels.length - 1];
    if (!panels.length || !dots.length) return;

    const setActive = (i) => {
        panels.forEach((panel, pi) => panel.classList.toggle('is-active', pi === i));
        dots.forEach((dot, di) => dot.classList.toggle('is-active', di === i));
    };

    dots.forEach((dot) => {
        dot.addEventListener('click', (e) => {
            const index = Number(dot.dataset.index);
            if (!Number.isFinite(index)) return;
            e.preventDefault?.();
            panels[index]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            setActive(index);
        });
    });

    let currentIndex = 0;
    let isScrollingDown = false;
    let lastScrollY = window.scrollY;
    let isAttachedToLastPanel = false;
    let isPastHeroPanels = false;
    let isReturningToHero = false;
    const SCROLL_DIRECTION_THRESHOLD = 2;

    const updateHeroScrollState = () => {
        const heroBottom = hero.getBoundingClientRect().bottom;
        isPastHeroPanels = heroBottom <= window.innerHeight;
    };

    const updateAttachOffset = () => {
        if (!heroIndex || !lastPanel) return;
        const navbarHeight = parseFloat(
            getComputedStyle(document.documentElement).getPropertyValue('--navbar-desktop-height')
        ) || 0;
        heroIndex.style.setProperty('--hero-index-attach-top', `${lastPanel.offsetTop + navbarHeight}px`);
    };

    const updateVisibility = () => {
        if (!heroIndex) return;
        heroIndex.classList.toggle('is-hidden', isPastHeroPanels && !isAttachedToLastPanel);
    };

    const setAttachedToLastPanel = (shouldAttach) => {
        if (!heroIndex || isAttachedToLastPanel === shouldAttach) return;
        isAttachedToLastPanel = shouldAttach;
        heroIndex.classList.toggle('is-attached-last-panel', shouldAttach);
        updateVisibility();
    };

    const syncAttachState = () => {
        if (!heroIndex || !lastPanel) return;
        const isOnLastPanel = currentIndex === panels.length - 1;
        const shouldAttach =
            isOnLastPanel &&
            isPastHeroPanels &&
            isScrollingDown &&
            !isReturningToHero;
        setAttachedToLastPanel(shouldAttach);
    };

    const io = new IntersectionObserver((entries) => {
        const visible = entries
            .filter(e => e.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (!visible) return;
        if (visible.target.parentElement !== hero) return;

        const index = panels.indexOf(visible.target);
        if (index >= 0 && index !== currentIndex) {
            currentIndex = index;
            setActive(index);
            syncAttachState();
        }
    }, { threshold: [0.6] });

    panels.forEach(panel => io.observe(panel));
    setActive(0);

    if (heroIndex) {
        updateAttachOffset();
        updateHeroScrollState();
        window.addEventListener('resize', () => {
            updateAttachOffset();
            updateHeroScrollState();
            syncAttachState();
            updateVisibility();
        });

        window.addEventListener('scroll', () => {
            const scrollY = window.scrollY;
            const delta = scrollY - lastScrollY;
            if (Math.abs(delta) >= SCROLL_DIRECTION_THRESHOLD) {
                isScrollingDown = delta > 0;
            }
            lastScrollY = scrollY;
            updateHeroScrollState();
            if (!isPastHeroPanels) {
                isReturningToHero = false;
            } else if (delta <= -SCROLL_DIRECTION_THRESHOLD) {
                isReturningToHero = true;
            }
            syncAttachState();
            updateVisibility();
        }, { passive: true });

        syncAttachState();
        updateVisibility();
    }
}
